import { Categories, Hierarchy } from '@/types/work/product_category';

export interface PublicCategory extends Hierarchy{
  title: String
}
export class PublicCategories extends Categories {}
